<template>
  <div class="wrapper-content">
    <LmComponentLoading v-if="isLoading" fixed />
    <h1>Ajustes</h1>
    <p>En este sección puede configurar ciertos parámetros de la aplicación.</p>
    <b-tabs>
      <b-tab title="Documentos" active class="py-4">
        <h3>Opciones de PDF</h3>
        <b-row>
          <LmTextInput
            class="col-12 col-md-3"
            label="Título del encabezado"
            placeholder="Título del encabezado"
            v-model="settings.documents.pdfHeader"
          />
          <LmTextInput
            class="col-12 col-md-3"
            label="Subtítulo del encabezado"
            placeholder="Subtítulo del encabezado"
            v-model="settings.documents.pdfSubHeader"
          />
          <div class="col-12 col-md-3 overlay-image">
            <span class="d-block">Logo del encabezado</span>
            <div class="img-wrap" v-b-modal.logo-pdf-cropper-modal v-if="pdfLogoPreviewSrc">
              <b-img class="img-preview" center thumbnail :src="pdfLogoPreviewSrc"></b-img>
              <div class="img-description-layer">
                <p class="img-description">Editar logo</p>
              </div>
            </div>
            <div
              v-else
              v-b-modal.logo-pdf-cropper-modal
              class="empty-logo d-flex justify-content-center align-items-center">
              <p class="mb-0">Carga un logo desde acá</p>
            </div>
          </div>

        </b-row>
      </b-tab>
      <b-tab title="Templates de Email" class="py-4">
        <h3>Documentos</h3>
        <b-row>
          <LmTreeSelect
            class="col-12 col-md-3"
            label="Notificación de documento a firmar"
            :options="mailertemplateOptions"
            v-model="settings.mailerTemplates.signersEmailTemplate"
          />
          <LmTreeSelect
            class="col-12 col-md-3"
            label="Documento Finalizado"
            :options="mailertemplateOptions"
            v-model="settings.mailerTemplates.documentFinishedEmailTemplate"
          />
          <LmTreeSelect
            class="col-12 col-md-3"
            label="Notificación para participante externo"
            :options="mailertemplateOptions"
            v-model="settings.mailerTemplates.externalEmailTemplate"
          />
        </b-row>
        <hr class="w-100">
        <h3>Trámites</h3>
        <b-row>
          <LmTreeSelect
            class="col-12 col-md-3"
            label="Notificaciones"
            :options="mailertemplateOptions"
            v-model="settings.mailerTemplates.processNotification"
          />
          <LmTreeSelect
            class="col-12 col-md-3"
            label="Trámite listo para descargar"
            :options="mailertemplateOptions"
            v-model="settings.mailerTemplates.processZipReady"
          />
        </b-row>
      </b-tab>

      <b-tab title="Personalización" class="py-4">
        <h3>Personalización</h3>
        <b-row>
          <div class="col-12 col-md-3 overlay-image">
            <span class="d-block mb-2">Logo para el encabezado</span>
            <div class="img-wrap mt-2" v-b-modal.logo-1-cropper-modal v-if="appLogo1">
              <b-img class="img-preview" center thumbnail :src="appLogo1"></b-img>
              <div class="img-description-layer">
                <p class="img-description">Editar logo</p>
              </div>
            </div>
            <div
              v-else
              v-b-modal.logo-1-cropper-modal
              class="empty-logo d-flex justify-content-center align-items-center">
              <p class="mb-0">Carga un logo desde acá</p>
            </div>
          </div>

        </b-row>
      </b-tab>
    </b-tabs>
    <hr class="w-100">
    <LmButton
      :value="$t('save')"
      buttonClass="btn-primary"
      @click="onSave"
    />

    <b-modal id="logo-pdf-cropper-modal" no-close-on-backdrop title="Editar logo para encabezado" size="xl">
      <div id="image-for-avatar-wrapper" class="row">
        <div class="col-12">
          <LmProfileCropper
            ref="lmCropperAppLogoPdf"
            hideSaveButton
            hideCropButton
            hideCropImg
            imgToCropWidthAsContainer
            :viewMode="1"
            labelFile="Logo del encabezado"
            @input="settings.documents.pdfLogo = $event; closeCropper('logo-pdf-cropper-modal', 'lmCropperAppLogoPdf');"
            @imageLoadedToBeCrop="isImageLoadedToBeCrop = true"
            @reset="isImageLoadedToBeCrop = false"
            :imgSrc="imageToCrop"
            />
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <LmButton
            :disabled="!isImageLoadedToBeCrop"
            id="btn-crop-save-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-primary"
            value="Guardar"
            class="float-right"
            @click="cropImage('lmCropperAppLogoPdf')"
          />
          <LmButton
            id="btn-crop-cancel-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            class="float-right"
            @click="closeCropper('logo-pdf-cropper-modal', 'lmCropperAppLogoPdf')"
          />
        </div>
      </template>
    </b-modal>

    <b-modal id="logo-1-cropper-modal" no-close-on-backdrop title="Editar logo del encabezado" size="xl">
      <div id="image-for-avatar-wrapper" class="row">
        <div class="col-12">
          <LmProfileCropper
            ref="lmCropperAppLogo1"
            hideSaveButton
            hideCropButton
            hideCropImg
            imgToCropWidthAsContainer
            :viewMode="1"
            labelFile="Logo del encabezado"
            @input="settings.customization.appLogo1 = $event; closeCropper('logo-1-cropper-modal', 'lmCropperAppLogo1');"
            @imageLoadedToBeCrop="isImageLoadedToBeCrop = true"
            @reset="isImageLoadedToBeCrop = false"
            :imgSrc="imageToCrop"
            />
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <LmButton
            :disabled="!isImageLoadedToBeCrop"
            id="btn-crop-save-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-primary"
            value="Guardar"
            class="float-right"
            @click="cropImage('lmCropperAppLogo1')"
          />
          <LmButton
            id="btn-crop-cancel-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            class="float-right"
            @click="closeCropper('logo-1-cropper-modal', 'lmCropperAppLogo1')"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import LmProfileCropper from '@/components/LmProfileCropper.vue'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmButton from '@/components/form/elements/LmButton'

import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmTextInput,
    LmColorPicker,
    LmUploadFiles,
    LmButton,
    LmProfileCropper
  },
  data () {
    return {
      isLoading: false,
      isImageLoadedToBeCrop: false,
      imageToCrop: '',
      mailertemplateOptions: [],
      settings: {
        documents: {
          pdfHeader: null,
          pdfSubHeader: null,
          pdfLogo: null
        },
        mailerTemplates: {
          signersEmailTemplate: null,
          documentFinishedEmailTemplate: null,
          externalEmailTemplate: null,
          processZipReady: null,
          processNotification: null
        },
        customization: {
          appLogo1: null
        }
      }
    }
  },
  computed: {
    mailerTemplatePath () {
      return '/mailertemplate/all?type=email&format=minimal'
    },
    pdfLogoPreviewSrc () {
      if (this.settings?.documents?.pdfLogo?.path) {
        return process.env.VUE_APP_API_URL_STATIC_ASSETS + this.settings.documents.pdfLogo.path
      }
      return null
    },
    appLogo1 () {
      if (this.settings?.customization?.appLogo1?.path) {
        return process.env.VUE_APP_API_URL_STATIC_ASSETS + this.settings.customization.appLogo1.path
      }
      return null
    }
  },
  methods: {
    async onSave () {
      try {
        this.isLoading = true
        await commonsApi.axiosPutWrapper('/customersettings/update', this.settings)
        this.lmToastSuccessMessage('Se guardaron los cambios.', 'Se guardó exitosamente')
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    cropImage (ref) {
      this.$refs[ref].crop()
      this.$refs[ref].submit()
    },

    closeCropper (id, ref) {
      this.$forceUpdate()
      this.$bvModal.hide(id)
      this.imageToCrop = ''
      this.$refs[ref].reset()
    }
  },
  async created () {
    try {
      this.isLoading = true
      const mailertemplateResponse = await commonsApi.axiosGetWrapper(this.mailerTemplatePath)
      this.mailertemplateOptions = mailertemplateResponse.data.items.map(el => ({ id: el._id, name: el.name }))

      const settings = await commonsApi.axiosGetWrapper('/customersettings/mysettings/documents,mailerTemplates,customization')

      for (const key in settings.data) {
        for (const innerKey in settings.data[key]) {
          this.settings[key][innerKey] = settings.data[key][innerKey]
        }
      }

      // this.settings.documents.signersEmailTemplate = this.mailertemplateOptions.find(opt => opt.id === this.defaults.signersEmailTemplate)
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
<style lang="sass">
.overlay-image
  .empty-logo
    margin-top: 14px
    width: 300px
    height: 38px
    background-color: #eaeaea
    border-radius: 5px
    border: 2px dashed #d1d0d0
  .img-wrap
    margin-top: 12px
    position: relative
    cursor: pointer
  .img-preview
    max-width: auto
    height: 40px
  .img-description-layer
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    border-radius: 5px
    background: var(--app-accent-color)
    color: #fff
    visibility: hidden
    opacity: 0
    display: flex
    align-items: center
    justify-content: center
    transition: opacity .2s, visibility .2s
  .img-wrap:hover .img-description-layer
    visibility: visible
    opacity: 1
  .img-description
    margin-bottom: 0
    transition: .2s
    transform: translateY(1em)
    text-transform: uppercase
  .img-wrap:hover .img-description
    transform: translateY(0)
</style>
